import { Component, Input, OnChanges } from '@angular/core';
import { VoltageSpeedChargingAssessment, VoltageSpeedDashboardSample } from '../../voltage-with-speed.models';
import { buildChargingStability } from './charging-stability.utils';

@Component({
  selector: 'app-voltage-speed-charging-stability',
  templateUrl: './charging-stability.component.html',
  styleUrls: ['./charging-stability.component.css']
})
export class VoltageSpeedChargingStabilityComponent implements OnChanges {
  @Input() assessment: VoltageSpeedChargingAssessment | null = null;
  @Input() samples: VoltageSpeedDashboardSample[] = [];

  view = buildChargingStability(null, []);

  ngOnChanges(): void {
    this.view = buildChargingStability(this.assessment, this.samples);
  }
}
